const Marionette = require('lib/marionette')
const SignupUser = require('module/user/signup_user')
const ProfileUser = require('module/user/profile_user')
const Storage = require('lib/localstorage')
const radio = require('lib/radio')
const triggerError = require('./steps/trigger_error')
const log = require('log').create('signup', 'user')  

const channel = radio.signup

// expiration time for stored user model
// millliseconds in one day
const expiration_time = 1000 * 60 * 60 * 24

// key for localstorage of user model
const SIGNUP_STORAGE_KEY = require('./storage_key')


const UserController = Marionette.MnObject.extend({

    initialize() {

        // create the user
        // before create, check if channel user is already existing;
        // usecase: homepage now allow user to type in email directly
        this.user = channel.request('user') || new SignupUser()

        // set user listeners

        // reset FC data whenever email address changes
        this.listenTo(this.user, 'change:email_address', () => {
            this.storeUser()
        })

        // log the id when it's set
        this.listenTo(this.user, `change:${this.user.idAttribute}`, () => {
            log('id', this.user.id)
            log(this.user.url())
        })

        // Checks if the user has started signing up / is returning to the page.
        // read stored attributes, using an empty object as fallback
        const attributes = Storage.get(SIGNUP_STORAGE_KEY, {})
        log('attributes', attributes)
        this.user.set(attributes)

        // set up channel replies and listeners
        channel.reply('user', () => this.user)
        channel.reply('create:profile_user', this.createProfileUser, this)
        channel.reply('profile_user', () => this.profile_user)
        channel.reply('save', this.storeUser, this)
        channel.reply('reset', this.resetUser, this)
        channel.reply('purge', this.purgeUser, this)

        // Update the local storage version when we switch step views
        this.listenTo(channel, 'show:step', this.onShowStep)

        // listen for complete event and purge user storage
        this.listenTo(channel, 'complete', this.purgeUser)


        if (__DEBUG__) {
            // expose user
            try {
                window.AboutMe.user = this.user
            } catch (err) {
                log(err)
            }
        }

    },

    onUserEvent(name) {
        log('user event', name)
    },

    onShowStep(data) {
        if (this.user.isNew()) {
            this.user.set('signup.step', data.step)
        } else {
            this.user.get('signup').patch('step', data.step).fail(triggerError)
        }
        this.storeUser()
    },

    purgeUser() {
        // purges user from localstorage
        Storage.deleteKey(SIGNUP_STORAGE_KEY)
        log('purged')
    },

    resetUser() {
        // special case, need to keep this value through reset.
        // wanted to make a reusable method using user.pick()
        // to grab a list of 'survivor' attrs to re-set after reset,
        // but _.pick doesn't work with nested keys like signup.iwantpro,
        // so just doing this for now
        const i_want_pro = !! this.user.get('signup.iwantpro')
        const enable_signature = !! this.user.get('signup.enable_signature')

        // purge the user and empty their data
        this.purgeUser()
        this.user.clear({ silent: true })
        this.user.set(SignupUser.prototype.defaults, { silent: true })

        // re-set i_want_pro, enable_signature
        this.user.set('signup.iwantpro', i_want_pro)
        this.user.set('signup.enable_signature', enable_signature)

        log('reset', this.user.toJSON())
    },

    storeUser() {
        // save the user data to localstorage
        const attributes = this.user.toJSON()
        Storage.set(SIGNUP_STORAGE_KEY, attributes, { TTL: expiration_time })
        log('stored')
    },

    createProfileUser(res) {
        this.profile_user = new ProfileUser(res)
        return this.profile_user
    },

})

module.exports = UserController
